var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 718.79,
    height: 793.04,
    viewBox: "0 0 190.1809 209.82444",
    id: "svg12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 55.415894,109.08514 c -50.5520004,50.552 -31.982,154.75 -50.5520004,51.583",
    id: "path4",
    style: {
      strokeWidth: "0.45243001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 140.74943,8.4866346 45.8,47.3270004",
    id: "path6",
    style: {
      strokeWidth: "0.33475px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 186.54943,6.9566346 -45.8,52.6700004",
    id: "path8",
    style: {
      strokeWidth: "0.33475px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.c25725c52d818002838ae3c1728eb1b3.svg";
export { ForwardRef as ReactComponent };